import React from 'react';
import { useParams } from 'react-router-dom';
import PaymentFailure from '../components/payments/PaymentFailure';

function PaymentFailurePage() {
    const { uid } = useParams(); // Token from URL
    return <PaymentFailure token={uid} />;
}

export default PaymentFailurePage;
